import React, { Component } from 'react';
import { Container, Header, Segment, Button, Grid, Dropdown } from 'semantic-ui-react';
import AddVideoGuideModal from './addvideoguidemodal'; // This is the modal component for adding video guides
import * as api from '../../api';
import { AuthService } from '../../services/auth-service';

class VideoGuideList extends Component {
  constructor(props) {
    super(props);
    this.authServices = new AuthService();

    this.state = {
      isAdmin: false, // Default to false until the check is complete
      selectedCategory: 'All',
      videoGuides: [],
      categories: [
        { key: 'all', text: 'All', value: 'All' },
        { key: 'std', text: 'Standard COTS', value: 'Standard COTS' },
        { key: 'hhd', text: 'Half Hourly Data', value: 'Half Hourly Data' },
        { key: 'qc', text: 'Queries and Cases', value: 'Queries and Cases' },
      ],
    };
  }

  componentDidMount() {
    this.fetchVideoGuides();

            // Check if the user is an admin
    this.checkAdminStatus();
  }

  checkAdminStatus = async () => {
    const isAdmin = await this.authServices.isUserAdmin();
    this.setState({ isAdmin });
  };
  fetchVideoGuides = () => {
    api.getVideoGuides() // Define this method in your api.js
      .then(videoGuides => {
        this.setState({ videoGuides });
      })
      .catch(err => {
        console.error(err);
      });
  };

  filterVideoGuides = (category) => {
    const { videoGuides } = this.state;
    return category === 'All'
      ? videoGuides
      : videoGuides.filter(guide => guide.category === category);
  };

  handleCategoryChange = (e, { value }) => {
    this.setState({ selectedCategory: value });
  };
  

  handleDeleteGuide = (videoId) => {
    api.deleteVideoGuide(videoId) // Define this in api.js
      .then(() => {
        this.fetchVideoGuides();
      })
      .catch(err => {
        console.error(err);
      });
  };



  renderVideoGuides() {
    const { isAdmin, selectedCategory } = this.state;
    const filteredGuides = this.filterVideoGuides(selectedCategory);

    return (
      <Grid columns={2} divided>
        {filteredGuides.map(guide => (
          <Grid.Column key={guide.videoID}>
            <Segment attached>
              <Header as='h3'>{guide.title}</Header>
              <p>{guide.description}</p>
              <iframe
                width="100%"
                height="315"
                src={guide.vimeoLink}
                title={guide.title}
                allow="autoplay; fullscreen; picture-in-picture"
                frameBorder="0"
                allowFullScreen
              ></iframe>
              {isAdmin && (
                <Button color='red' onClick={() => this.handleDeleteGuide(guide.videoID)}>
                  Delete Guide
                </Button>
              )}
            </Segment>
          </Grid.Column>
        ))}
      </Grid>
    );
  }

  render() {
    const { isAdmin } = this.state;

    return (
      <Container fluid>
        {isAdmin && (
          <div>
            <Header as='h1'>Video Guide Manager</Header>
            <AddVideoGuideModal onNewGuide={this.fetchVideoGuides} />
          </div>
        )}
        <Header as='h2'>Categories</Header>
        <Dropdown
  placeholder='Select Category'
  fluid
  selection
  options={this.state.categories}
  value={this.state.selectedCategory}
  onChange={this.handleCategoryChange}
/>

<Header as='h2' attached='top'>
  Video Guides - {this.state.selectedCategory}
</Header>


        {this.renderVideoGuides()}
      </Container>
    );
  }
}

export default VideoGuideList;
